module.exports = __webpack_public_path__ + "media/images/staffco-logo-7385c706c9ef226682e901468b003afb.png";